import React, { useState } from "react";
import { Button, Icon, Confirm, Popup } from "semantic-ui-react";
import { Role } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./RolePermissionItem.scss";

const roleController = new Role();

export function RolePermissionItem(props) {
  const { rolePermission, onReload } = props;
  const { accessToken } = useAuth();

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openDeleteConfirm = () => {
    setConfirmMessage(
      `¿Eliminar el permiso "${rolePermission.Permission.name}" del tipo de usuario?`
    );
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await roleController.deleteRolePermission(rolePermission.id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="syllaby-subject-grade-item">
        <div className="syllaby-subject-grade-item__info">
          <span className="syllaby-subject-grade-item__info-grade">
            {rolePermission.Permission?.name}
          </span>
        </div>
        <div className="syllaby-subject-grade-item__info">
          <span className="syllaby-subject-grade-item__info-subject">
            {rolePermission.Permission?.description}
          </span>
        </div>
        <Popup
          content="Eliminar permiso"
          trigger={
            <Button icon color="red" onClick={openDeleteConfirm}>
              <Icon name="trash" />
            </Button>
          }
        />
      </div>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
